import { LocalizedPaths } from "../../../types/gatsby";
import { Maybe } from "../../../types/graphql-types";
import { isPresent } from "../checks";
import { stringPresent } from "../strings";

function legacyUrl(path: undefined | null): undefined;
function legacyUrl(path: string): string;
function legacyUrl(path: Maybe<string>): string | undefined;
function legacyUrl(path: string | undefined | null): string | undefined {
  if (!isPresent(path)) return undefined;
  if (path == "/") return path;
  if (path.endsWith(".html")) return path;

  return `${path}.html`;
}

export const stripLegacyUrl = (
  path: string | undefined
): string | undefined => {
  if (!path) return path;
  if (path.endsWith(".html")) return path.slice(0, -5);
  return path;
};

function legacyUrls(paths: LocalizedPaths): LocalizedPaths {
  return Object.keys(paths).reduce<LocalizedPaths>((links, languageCode) => {
    const path = legacyUrl(paths[languageCode]);
    if (path) links[languageCode] = path;
    return links;
  }, {});
}

function urlWithFullDomain(url: string): string;
function urlWithFullDomain(url: string | undefined): string | undefined;
function urlWithFullDomain(url: string | undefined): string | undefined {
  if (!stringPresent(url)) return undefined;
  if (url.startsWith("http")) return url;
  if (url[0] == "/") return `https://www.silversea.com${url}`;

  return `https://www.silversea.com/${url}`;
}

// eslint-disable-next-line import/no-unused-modules
export { legacyUrl, legacyUrls, urlWithFullDomain };
